<template>
    <div :class="['container', { 'container-dark': theme_dark }]">
      <div class="nav-top">
        <div class="nav-left" @click="back()">
          <img src="../../assets/img/返回箭头.png" class="nav-img" />
          <span class="nav-lable"></span>
        </div>
        <div class="nav-middle">聊天评价</div>
        <div class="nav-right">
          <span class="nav-lable"></span>
          <img src class="nav-img none" />
        </div>
      </div>

      <ul class="evaluate-block" v-for="(item,index) in arr" :key="index" >
        <li>
            <div class="ub ub-pc evaluate-item">
                <img :src="item.photo" class="evaluate-img" />
                <div class="evaluate-info ub ub-ver ub-f1">
                  <div class="evaluate-name ub">
                      <span>{{ item.nick }}</span>
                      <div class="age">
                      <span>{{ item.age_range }}</span>
                      </div>
                  </div>

                  <div class="num">
                      <span>豪气值: <label>{{ item.coin_total }}</label></span>
                      <span>魅力值: <label>{{ item.score_total }}</label></span>
                  </div>

                  <div class="dtm">
                    <span>评价时间: {{ item.evaluate_dtm }}</span>
                  </div>
                </div>
                
                <div class="evaluate-state ub">
                  <div class="state1 ub ub-ver ub-pc" v-if="item.evaluate == '满意'">
                    <img class="img1" src="../../assets/img/new2024/evaluate-yes1.png" alt="">
                    <span>满意</span>
                  </div>
                  <div class="state2 ub ub-ver ub-pc" v-if="item.evaluate == '一般'">
                    <img class="img1" src="../../assets/img/new2024/evaluate-common1.png" alt="">
                    <span>一般</span>
                  </div>
                  <div class="state3 ub ub-ver ub-pc" v-if="item.evaluate == '差'">
                    <img class="img1" src="../../assets/img/new2024/evaluate-no1.png" alt="">
                    <span>差</span>
                  </div>
                </div>
            </div>
            <div class="menu-line"></div>
            </li>
        </ul>

        <div class="no-404 ub ub-pc ub-ac ub-ver" v-if="arr.length == 0" >
            <img src="../../assets/img/new2024/no-information.png" alt="">
            <span class="tip-404">恭喜你还没有差评哦</span>
        </div>

    </div>
  </template>
  
  <script>
  import * as tool from "../../api/common";
  import { mapMutations, mapActions } from "vuex";
  export default {
    data() {
      return {
        arr: [],
        theme_dark: false
      };
    },
    mounted() {
      //切换深色模式
      this.theme_dark = tool.is_theme_dark(this);
      this.init_page();
    },
    methods: {
      ...mapMutations(["get", "post"]), //引入方法
      ...mapActions(["act_get_userinfo"]), //引入方法
  
      back() {
        this.$router.go(-1); //返回上一层
      },
      init_page() {
        var uid = this.$store.state.uid;
        var self = this;
        this.get({
            url: "/App/Get_ChatevalData?uid=" + uid,
            success: function (data) {
              for (var i in data) {
                var user_item = data[i];
                user_item.photo = self.$store.state.url + "/photo/" + user_item.photo;
                user_item.eval_time = user_item.eval_time.replace(/-/g, "/");
                user_item.evaluate_dtm = self.get_block_time(user_item.eval_time);
              }
              self.arr = data;
            },
            error: function (err){}
          }); 
      },

      get_block_time(dtm) {
        var rtn = "";
        var dtm = new Date(dtm);
        var second = tool.dateDiff_Now(dtm);
        
        if (second < 60) {
            rtn = "刚刚";
        } 
        if (second >= 60 && second < 60 * 60) {
            var minutes = Math.floor(second / 60);
            rtn = minutes + "分钟前";
        } 
        if (second >= 60 * 60 && second < 60 * 60 * 24) {
            var hours = Math.floor(second / (60 * 60));
            rtn = hours + "小时前";
        } 
        if (second >= 60 * 60 * 24) {
            var days = Math.floor(second / (60 * 60 * 24));
            rtn = days + "天前";
        }
        return rtn;
      }
    },
  };
  </script>
  
<style lang="scss" scoped>
.container {
    min-height: 100vh;
    background-color: #FDFDFD;
}

.evaluate-block {
  overflow-x: hidden; /*隐藏ul x轴的滚动条*/
  padding: 0;
  margin: 0;
  .menu-line {
    border-top: 1px solid #EFEFEF;
  }
}

.evaluate-item {
    padding: 0.5rem 0.8rem;
    .evaluate-img {
      width: 3.5rem;
      height: 3.5rem;
      border-radius: 50%;
    }
    .evaluate-info {
      margin-left: 1rem;
      .evaluate-name {
        span {
          font-size: 0.9rem;
          font-weight: bold;
          color: #333;
        }
        .age span{
          padding: 0.2rem 0.5rem;
          margin-left: 0.5rem;
          font-size: 0.65rem;
          color: #666;
          border: 1px solid #dcdcdc;
          border-radius: 1rem;
        }
      }
      .num {
        margin-top: 0.5rem;
        span {
          font-size: 0.75rem;
          color: #333;
          label {
            font-size: 0.65rem;
            font-weight: bold;
            color: #BA61FF;
          }
        }
      }
      .num span:last-child{
        margin-left: 1rem;
      }
      .dtm {
        margin-top: 0.5rem;
        span {
          font-size: 0.75rem;
          color: #333;
        }
      }
    }
    .evaluate-state {
        .img1 {
          width: 2.2rem;
          height: 2.2rem;
        }
        .state1 {
          span {
                margin-top: 0.3rem;
                font-size: 0.9rem;
                color: blue;
          }
        }
        .state2 {
          span {
                margin-top: 0.3rem;
                font-size: 0.9rem;
                color: #333;
          }
        }
        .state3 {
          span {
                margin-top: 0.3rem;
                font-size: 0.9rem;
                color: red;
          }
        }
      }
  }

  .no-404 {
    margin-top: 10rem;
    background-size: 100% 100%;
    .tip-404 {
      margin-top: 1rem;
      font-size: 0.75rem;
      color: #666;
    }
  }

.container-dark {
    background-color: #2F2E33;
  .menu-line {
    border-top: 1px solid #404040;
  }
  .no-404 {
    .tip-404 {
      color: #dfdfdf;
    }
  }
}
  </style>
  